import { TableCell, TableRow, Box } from "@mui/material";
import TableSkeleton from "./TableSkeleton";

export default function TableLoadingState({
  loading,
  hasData,
  colSpan,
  emptyMessage,
  skeletonRows = 5,
}) {
  if (loading) {
    return (
      <TableSkeleton loading={loading} colSpan={colSpan} rows={skeletonRows} />
    );
  }

  if (!hasData) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} align="center" sx={{ py: 4 }}>
          <Box sx={{ color: "text.secondary", fontSize: "0.95rem" }}>
            {emptyMessage}
          </Box>
        </TableCell>
      </TableRow>
    );
  }

  return null;
}
